import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { PlantillaPdfDto } from '../dto/plantilla-pdf/plantilla-pdf.dto';

@Injectable({
  providedIn: 'root',
})
export class PlantillasPdfService {
  private apiUrl = `${environment.apiUrl}/plantilla-pdf`;

  constructor(private http: HttpClient) {}

  obtenerPlantillas(): Observable<PlantillaPdfDto[]> {
    return this.http.get<PlantillaPdfDto[]>(this.apiUrl);
  }

  modificarPlantilla(plantilla: FormData): Observable<any> {
    return this.http.put<void>(`${this.apiUrl}`, plantilla);
  }
}
